import { create } from "zustand";

const initialGoogleAuthState = {
  loading: false,
};

export type GoogleAuthState = typeof initialGoogleAuthState;

export const useGoogleAuthStore = create<GoogleAuthState>(() => ({
  ...initialGoogleAuthState,
}));
